module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_0.cacb56a4.png";